import api, { unwrapList } from './api';

const normalizeDriversResponse = (data) => ({
  rows: unwrapList(data),
  sync: Array.isArray(data) ? null : (data?.sync || null),
});

const driverService = {
  getAll:  (p)     => api.get('/drivers/', { params: p }).then(r => unwrapList(r.data)),
  getAllWithMeta: (p) => api.get('/drivers/', { params: p }).then((r) => normalizeDriversResponse(r.data)),
  getById: (id)    => api.get(`/drivers/${id}/`).then(r => r.data),
  getInsights: (id) => api.get(`/drivers/${id}/insights/`).then(r => r.data),
  getKPISettings: (id) => api.get(`/drivers/${id}/kpi-settings/`).then(r => r.data),
  updateKPISettings: (id, d) => api.patch(`/drivers/${id}/kpi-settings/`, d).then(r => r.data),
  create:  (d)     => api.post('/drivers/', d).then(r => r.data),
  update:  (id, d) => api.patch(`/drivers/${id}/`, d).then(r => r.data),
  delete:  (id)    => api.delete(`/drivers/${id}/`),
  reconcileClerk: (dryRun = true) =>
    api.post('/drivers/reconcile-clerk/', { dry_run: Boolean(dryRun) }).then((r) => r.data),
};
export default driverService;